import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — the payments of the period with the filters, the money and its chart */
export const list = data => {
    const uri = `${env.startpoint}/admin/transaction/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GET — one payment with everything around it ({ source, id }) */
export const get = data => {
    const uri = `${env.startpoint}/admin/transaction/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
